import * as React from "react";
const SvgFiBrandsHubspot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-hubspot_svg__a)">
      <path
        fill="#151A2D"
        d="M18.92 7.931V5.085c.802-.359 1.315-1.13 1.32-1.978V3.04C20.236 1.83 19.216.851 17.955.847h-.07c-1.26.003-2.28.983-2.284 2.193v.067c.004.85.518 1.62 1.319 1.978v2.852a6.6 6.6 0 0 0-3.08 1.301L5.685 3.142C6.056 1.81 5.232.442 3.844.085 2.455-.27 1.03.521.659 1.853c-.37 1.332.454 2.701 1.842 3.057a2.7 2.7 0 0 0 1.967-.247l8.016 5.991a6.03 6.03 0 0 0 .1 7.032l-2.44 2.342c-.195-.06-.4-.092-.604-.095-1.17 0-2.118.91-2.118 2.033C7.422 23.09 8.37 24 9.54 24s2.117-.91 2.117-2.033a2 2 0 0 0-.099-.58l2.414-2.318c2.856 2.094 6.94 1.57 9.12-1.172 2.182-2.74 1.635-6.662-1.22-8.756a6.65 6.65 0 0 0-2.956-1.209m-1 9.376c-1.843-.004-3.335-1.443-3.33-3.213.003-1.77 1.502-3.202 3.346-3.198 1.842.004 3.333 1.44 3.332 3.207 0 1.77-1.495 3.205-3.339 3.205"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-hubspot_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsHubspot;
